import { Text } from '@medly-components/core';
import StationIcon from 'components/common/StationIcon';
import { ZoneContext } from 'context/ZoneContext';
import { format } from 'date-fns';
import { useContext } from 'react';
import colors from 'theme/colors';
import { Header, LastUpdatedText, StationIconWrapper, StationInfo, StationText } from './DrawerHeader.styled';
import { getContentWithSearchHighlited } from 'pages/MapSearch/utils';
import useMapSearch from 'hooks/search/useMapSearch';

const OutputDateFormat = 'dd MMM yyyy';
type DrawerHeaderProps = {
    updatedAt?: string;
};
export const DrawerHeader = ({ updatedAt }: DrawerHeaderProps) => {
    const { selectedStation } = useContext(ZoneContext);
    const { getSearchWords } = useMapSearch();

    if (!selectedStation) {
        return null;
    }
    const searchWords = getSearchWords(selectedStation.id);

    const type = selectedStation.getType();
    const description = selectedStation.getDescription();

    return (
        <Header>
            <StationInfo>
                <StationIconWrapper>
                    <StationIcon type={type} />
                </StationIconWrapper>
                <StationText>
                    <Text textColor={colors.grey[700]}>{type}</Text>
                    <Text
                        textColor={colors.darkBlue}
                        textVariant="h4"
                        dangerouslySetInnerHTML={{ __html: getContentWithSearchHighlited(description, searchWords) }}
                    ></Text>
                </StationText>
            </StationInfo>
            {updatedAt ? <LastUpdatedText>{`Last updated on ${format(new Date(updatedAt), OutputDateFormat)}.`}</LastUpdatedText> : null}
        </Header>
    );
};
